import React, { forwardRef, useMemo } from 'react'
import { SVGIcon } from 'shared/ui'
import { isBotUser, isBridgeUser } from 'ducks/chat/utils/users'
import Meta from '@groovehq/internal-design-system/lib/assets/icons/logos/Meta'
import { styles } from './styles'

const CustomAvatar = forwardRef(({ idName }, ref) => {
  const isBot = useMemo(() => isBotUser(idName), [idName])
  const isBridge = useMemo(() => isBridgeUser(idName), [idName])
  return (
    <div css={styles.customAvatarContainer} ref={ref}>
      <div css={styles.avatar}>
        {isBot && (
          <SVGIcon name="robot" size={20} color="color.monochrome.dark" />
        )}
        {isBridge && <Meta width="32px" />}
      </div>
    </div>
  )
})

export default CustomAvatar
